import React from 'react';
import { CheckCircle2, AlertTriangle, Circle } from 'lucide-react';
import type { DossierTodo, DossierOverview } from '../../types';

interface Props {
  overview: DossierOverview;
}

export default function TodoSection({ overview }: Props) {
  const { todos, overallProgress, alerts } = overview;

  return (
    <div className="mb-4 p-4 bg-white border border-gray-200 rounded-lg">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-gray-800 flex items-center gap-2">
          <CheckCircle2 className="w-5 h-5 text-blue-500" />
          De făcut
        </h3>
        {(alerts.critical > 0 || alerts.warning > 0) && (
          <span className="flex items-center gap-1 text-xs">
            {alerts.critical > 0 && <span className="bg-red-100 text-red-700 px-2 py-0.5 rounded-full">{alerts.critical} critice</span>}
            {alerts.warning > 0 && <span className="bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">{alerts.warning} atenție</span>}
          </span>
        )}
      </div>

      {todos.length > 0 ? (
        <ul className="space-y-1.5 mb-3">
          {todos.map((todo, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              {todo.priority === 'high' ? (
                <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
              ) : (
                <Circle className="w-4 h-4 text-gray-300 flex-shrink-0 mt-0.5" />
              )}
              <span className="text-gray-600">{todo.message}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-gray-400 mb-3">Nicio acțiune necesară momentan.</p>
      )}

      <div className="flex items-center gap-3">
        <div className="flex-1 bg-gray-100 rounded-full h-2">
          <div
            className="h-2 rounded-full bg-blue-500 transition-all"
            style={{ width: `${overallProgress}%` }}
          />
        </div>
        <span className="text-sm font-medium text-gray-500">{overallProgress}%</span>
      </div>
    </div>
  );
}
